module.exports = __webpack_public_path__ + "img/view_empty.8eea7fac.png";